<div class="page__content">
  <div class="content__inner">
    <div class="register-form">
      <div class="row">
        <div class="col-sm-12">
          <h5 id="solicitud-titulo">{{procedimiento.Nombre}}
          </h5>
        </div>
      </div>
      <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-clip-rotate" [fullScreen]="true" [name]="'tramite_dynamic_spinner'">
        <p style="color: white">{{mensajeSpinner}}</p>
      </ngx-spinner>
      <ng-container *ngIf="tramitedinamicoSubmit && tramitedinamicoSubmit.Pestanias">
        <ul class="nav nav-tabs nav-stepper" id="myTab" role="tablist">
          <li class="nav-item" *ngFor="let pestania of tramitedinamicoSubmit?.Pestanias">
            <a class="nav-link"
              [ngClass]="{ 'active': pestania.Orden === (tabIndexSelected+1), 'disabled': pestania.Orden > (tabIndexSelected+1)}"
              id="{{pestania.TagId}}" data-toggle="tab" href="'#'+{{pestania.TagId}}" role="tab" aria-controls="home"
              aria-selected="true" (click)="restauraPestaniaSeleccionada(pestania)">
              <span>{{pestania.Nombre}}</span>
            </a>
          </li>
        </ul>

        <div class="tab-content" id="myTabContent">

          <div class="tab-pane fade show active" id="tramitedinamicoSubmit?.Pestanias[tabIndexSelected]?.TagId"
            role="tabpanel" aria-labelledby="tramitedinamicoSubmit?.Pestanias[tabIndexSelected]?.TagId">

            <div>
              <ng-container *ngIf="tramitedinamicoSubmit?.Pestanias[tabIndexSelected]?.Titulo">
                <h3 class="tabtitle">{{tramitedinamicoSubmit?.Pestanias[tabIndexSelected]?.Titulo}}</h3>
              </ng-container>
              <div>
                <form [formGroup]="dynamicForm[tabIndexSelected]" (ngSubmit)="onSubmit()">
                  <div class="row">
                    <div *ngFor="let control of tramitedinamicoSubmit?.Pestanias[tabIndexSelected]?.Campos"
                      [ngClass]="getClassDiv(control)">
                      <ng-container *ngIf="control.TextoRepresentativo">
                        <div [innerHTML]="control.TextoRepresentativo"></div>

                        <div class="smallInfo pl-3">
                          <label class="form-check-label">
                            <ng-container *ngIf="control.Tipo === 'checkbox'">
                              <mat-checkbox class="form-check-input" [formControlName]="control.Nombre"
                                id="{{control.Nombre}}"
                                [ngClass]="{'is-invalid': dynamicForm[tabIndexSelected].get(control.Nombre).invalid && dynamicForm[tabIndexSelected].get(control.Nombre).touched}"></mat-checkbox>
                            </ng-container>
                            {{control.Label}} <span
                              *ngIf="control.Validaciones  && esCampoObligatorio(control ) && !control.TextoRepresentativo"
                              class="mandatoryLabel">*</span>
                          </label>
                          <!-- <ng-container *ngIf="control.Validaciones  && esCampoObligatorio(control ) ">
                            <label class="mandatoryLabel">*</label>
                          </ng-container> -->
                        </div>
                        <br />
                      </ng-container>
                      <ng-container *ngIf="control.TituloEnfatizado">
                        <h3 class="w-100 tabtitle">{{control.TituloEnfatizado}}</h3>
                      </ng-container>
                      <label class="tinyLabel" *ngIf="!control.TextoRepresentativo">{{control.Label}} <span
                          *ngIf="control.Validaciones  && esCampoObligatorio(control ) && !control.TextoRepresentativo"
                          class="mandatoryLabel">*</span></label>
                      <!-- <ng-container
                        *ngIf="control.Validaciones  && esCampoObligatorio(control ) && !control.TextoRepresentativo">
                        <label class="mandatoryLabel">*</label>
                      </ng-container> -->

                      <ng-container *ngIf="control.Tipo && !control.TextoRepresentativo">
                        <ng-container
                          *ngIf="control.Tipo != 'select' && control.Tipo != 'textarea' && control.Tipo != 'multiselect'">
                          <br />
                          <ng-container *ngIf="!control.Documento">
                            <input [type]="control.Tipo" [formControlName]="control.Nombre" id="{{control.Nombre}}"
                              [attr.class]="control.Tipo ==='file' ? '':'form-control'"
                              [ngClass]="{'is-invalid': dynamicForm[tabIndexSelected].get(control.Nombre).invalid && dynamicForm[tabIndexSelected].get(control.Nombre).touched}"
                              [attr.accept]=" control.Tipo ==='file' ? tipoFicherosPermitiros: null"
                              (change)="control.Tipo === 'file' && onFileChange($event, control.Nombre)">
                          </ng-container>
                          <div *ngIf="control.Tipo === 'file' && control.Documento">
                            <label class="font-weight-bold titleFiles">{{ 'TRAMITE.FILE.NAME' | translate }}</label>
                            <td>{{control.Documento.Nombre}}</td>
                            <br />
                            <td>
                              <button (click)="removeFile(control.Nombre)" class="btn btn-danger">{{ 'TRAMITE.FILE.DELETE' | translate }}</button>
                            </td>
                          </div>
                        </ng-container>

                        <ng-container *ngIf="control.OpcionesListado && control.Tipo === 'select'">
                          <select [formControlName]="control.Nombre" class="form-control" id="{{control.Nombre}}"
                            [ngClass]="{'is-invalid': dynamicForm[tabIndexSelected].get(control.Nombre).invalid && dynamicForm[tabIndexSelected].get(control.Nombre).touched}">
                            <option *ngFor="let opcion of control.OpcionesListado" [value]="opcion.Id">
                              {{ opcion.Label }}
                            </option>
                          </select>
                        </ng-container>

                        <ng-container *ngIf="control.OpcionesListado && control.Tipo === 'multiselect'">
                          <mat-form-field class="w-100">
                            <mat-select [formControlName]="control.Nombre" [disabled]="control.disabled" multiple
                              [ngClass]="{'is-invalid': dynamicForm[tabIndexSelected].get(control.Nombre).invalid && dynamicForm[tabIndexSelected].get(control.Nombre).touched}"
                              class="custom-select">
                              <mat-option *ngFor="let opcion of control.OpcionesListado" [value]="opcion.Id">
                                {{ opcion.Label }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </ng-container>

                        <ng-container *ngIf="control.Tipo  && control.Tipo == 'textarea'">
                          <textarea rows="4" class="w-100" [formControlName]="control.Nombre" id="{{control.Nombre}}"
                            [ngClass]="{'is-invalid': dynamicForm[tabIndexSelected].get(control.Nombre).invalid && dynamicForm[tabIndexSelected].get(control.Nombre).touched}">
                          </textarea>
                        </ng-container>
                      </ng-container>
                      <span
                        *ngIf="control.Nombre && dynamicForm[tabIndexSelected].get(control.Nombre).invalid && dynamicForm[tabIndexSelected].get(control.Nombre).touched">
                        <br />
                        <b>{{getMensajeError(control)}}</b>
                      </span>

                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                      <button type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                      <button [disabled]="tabIndexSelected == 0" type="button" class="btn btn-primary mt-2 mr-2"
                        (click)="volver()">
                        Volver
                      </button>
                      <ng-container *ngIf="tabIndexSelected < tramitedinamicoSubmit.Pestanias?.length  -1">
                        <button type="submit" id="submitForm" class="btn btn-primary mt-2"
                          [disabled]="dynamicForm[tabIndexSelected].invalid">{{ 'COMMON.BUTTON.NEXT' | translate }}</button>
                      </ng-container>
                      <ng-container *ngIf="tabIndexSelected == tramitedinamicoSubmit.Pestanias?.length  -1">
                        <fieldset [disabled]="isSigning || dynamicForm[tabIndexSelected].invalid">
                          <boton-listado id="submitForm">
                          </boton-listado>
                        </fieldset>
                      </ng-container>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

    </div>
  </div>
  <form id="firma" (submit)="resultchange($event)" class="">
    <input type="hidden" id="result" />
    <input type="hidden" id="error" />
    <input type="hidden" id="certifcado" />
  </form>
